export const NAME = 'apartments';
